module.exports = __webpack_public_path__ + "static/media/doc.4ad58751.svg";